// src/hooks/useLogArtworkViewOnce.js
import { useEffect, useRef } from "react";
import { logArtworkAccess } from "../utils/artworkAccess";

export function useLogArtworkViewOnce({ artworkId, enabled, source = "artwork_detail" }) {
  const loggedRef = useRef(false);

  useEffect(() => {
    if (!enabled) return;
    if (!artworkId) return;
    if (loggedRef.current) return;

    let cancelled = false;

    (async () => {
      const { ok, error } = await logArtworkAccess({ artworkId, action: "view", source, note: null });
      if (cancelled) return;

      if (!ok) {
        // on laisse loggedRef à false pour éventuellement retenter au prochain render
        console.warn("[useLogArtworkViewOnce] log failed", error?.message || error);
        return;
      }

      loggedRef.current = true;
    })();

    return () => {
      cancelled = true;
    };
  }, [artworkId, enabled, source]);
}
